<template>
  <div class="flex flex-row" style="position: fixed;z-index:1; width: 880px;">
    <app-table v-bind="$attrs" class="table-auto w-full">
      <template v-slot:table-body>
        <tr
          class="border border-collapse border-dashed border-blue border-t-0 border-l-0 border-r-0 h-12"
          v-for="(header, index) in headers"
          :key="index"
        >
          <td
            class="mt-2 items-center justify-center"
            style="width:30px; position: relative; top:3px;"
            v-if="currentPoliticalAction.report.option.viewType == 4"
          >
            <approved-icn width="20" height="20" />
          </td>
          <td
            class="mt-2 items-center justify-center"
            style="width:30px; position: relative; top:3px;"
            v-else-if="currentPoliticalAction.report.option.viewType === 1"
          >
            <approved-icn class="status-green" width="20" height="20" />
          </td>
          <td
            class="mt-2 items-center justify-center"
            style="width:30px; position: relative;"
            :class="header.attr == 'files' ? 'align-top' : ''"
            :style="header.attr == 'files' ? 'top:12px;' : 'top:3px;'"
            v-else
          >
            <rejected-icn
              v-if="
                ((currentPoliticalAction.report.option.viewType === 7 ||
                  currentPoliticalAction.report.option.viewType === 3) &&
                  sentBackTitle().includes(
                    header.attr
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase(),
                  )) ||
                  header.comment
              "
              class="mb-1"
              width="20"
              height="20"
            />
            <wait-yellow-icn v-else width="20" height="20" />
          </td>
          <td :class="header.attr == 'files' ? 'align-top' : ''" width="150px">
            <div v-if="header.attr == 'files'" class="mt-2 mb-2">
              <span class="text-lg text-blue font-bold"
                >{{ header.title }}
                {{ currentPoliticalAction.report['images'].length }}</span
              ><br />
              <!-- <span class="text-blue">画像クリックで</span><br />
              <span class="text-blue">拡大表示</span> -->
            </div>
            <span v-else class="text-lg text-blue font-bold">{{
              header.title
            }}</span>
          </td>
          <td v-if="header.attr == 'submissionDate'">
            <AppPreviewSentBackItem
              color="blue"
              :message="
                getSentBackItemMessage(
                  header.attr
                    .split(/(?=[A-Z])/)
                    .join('_')
                    .toLowerCase(),
                )
              "
            />
            <div v-if="header.comment" class="flex flex-row items-center">
              <rejected-icn
                class="mt-1.5 mr-1"
                style="display: inline-block;"
                width="16"
                height="16"
              />
              <span
                class="text-lg mt-1"
                style="width: 590px; white-space: normal; align-items: center;"
              >
                {{ header.comment }}<br />
              </span>
            </div>
            <span class="text-lg">
              {{
                $filters.dateFormat(
                  currentPoliticalAction.report['submissionDate'],
                )
              }}
            </span>
          </td>
          <td
            v-else-if="header.attr == 'files' && imgUploader.imgs.length > 0"
            class="pt-2"
          >
            <AppPreviewSentBackItem
              color="blue"
              :message="
                getSentBackItemMessage(
                  header.attr
                    .split(/(?=[A-Z])/)
                    .join('_')
                    .toLowerCase(),
                )
              "
            />
            <div v-if="header.comment" class="flex flex-row items-center">
              <rejected-icn
                class="mt-1.5 mr-1"
                style="display: inline-block;"
                width="16"
                height="16"
              />
              <span
                class="text-lg mt-1"
                style="width: 590px; white-space: normal; align-items: center;"
              >
                {{ header.comment }}<br />
              </span>
            </div>
            <span class="text-lg">
              <div
                v-for="(img, index) in currentPoliticalAction.report.images"
                :key="index"
              >
                <span
                  v-if="currentUser.role_id !== 1"
                  :class="`text-red mb-1 ml-1`"
                  >※画像クリックで黒塗りダイアログが開きます</span
                >
                <img
                  v-if="img.normalImage"
                  :src="
                    img.blackImage == null ? img.normalImage : img.blackImage
                  "
                  @click="
                    openImgPreview('result', index, {
                      normalImage: img.normalImage,
                      blackImage: img.blackImage,
                    })
                  "
                />
              </div>
            </span>
          </td>
          <td v-else-if="header.attr == 'overview'" class="pt-2">
            <AppPreviewSentBackItem
              color="blue"
              :message="
                getSentBackItemMessage(
                  header.attr
                    .split(/(?=[A-Z])/)
                    .join('_')
                    .toLowerCase(),
                )
              "
            />
            <div v-if="header.comment" class="flex flex-row items-center">
              <rejected-icn
                class="mt-1.5 mr-1"
                style="display: inline-block;"
                width="16"
                height="16"
              />
              <span
                class="text-lg mt-1"
                style="width: 590px; white-space: normal; align-items: center;"
              >
                {{ header.comment }}<br />
              </span>
            </div>
            <span
              class="overview text-lg"
              v-html="currentPoliticalAction.report[header.attr]"
            ></span>
          </td>
          <td v-else>
            <AppPreviewSentBackItem
              color="blue"
              :message="
                getSentBackItemMessage(
                  header.attr
                    .split(/(?=[A-Z])/)
                    .join('_')
                    .toLowerCase(),
                )
              "
            />
            <div v-if="header.comment" class="flex flex-row items-center">
              <rejected-icn
                class="mt-1.5 mr-1"
                style="display: inline-block;"
                width="16"
                height="16"
              />
              <span
                class="text-lg mt-1"
                style="width: 590px; white-space: normal; align-items: center;"
              >
                {{ header.comment }}<br />
              </span>
            </div>
            <span class="text-lg">{{
              currentPoliticalAction.report[header.attr]
            }}</span>
          </td>
        </tr>
      </template>
    </app-table>
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue'
import AppTable from '@/components/ui/AppTable'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import AppPreviewSentBackItem from '@/components/ui/AppPreviewSentBackItem'
import ApprovedIcn from '@/assets/icons/approved.svg?inline'
import WaitYellowIcn from '@/assets/icons/wait-yellow.svg?inline'
import { useResultReject } from '@/services/politicalAction/useResultReject'
import { usePoliticalActions } from '@/services/politicalAction/usePoliticalActions'
import { useResultForm } from '@/services/politicalAction/useResultForm'
import { useStatus } from '@/services/politicalAction/useStatus'
import { useImgUploader } from '@/services/useImgUploader'
import { useDialog } from '@/services/useDialog'
import { useCurrentUser } from '@/services/useCurrentUser'

export default {
  name: 'ResultPreview',

  components: {
    AppTable,
    RejectedIcn,
    ApprovedIcn,
    WaitYellowIcn,
    AppPreviewSentBackItem,
  },

  setup() {
    const { getIcon } = useStatus()
    const { imgUploader } = useImgUploader()
    const { rejectHeaders, rejectedAttrs } = useResultReject()

    const headers = reactive([
      { title: '基本情報', attr: 'submissionDate', comment: '' },
      { title: '概要', attr: 'overview', comment: '' },
      { title: '備考', attr: 'remarks', comment: '' },
      { title: '資料添付', attr: 'files', comment: '' },
    ])

    const { currentPoliticalAction } = usePoliticalActions()
    onMounted(() => {
      let images = []
      if (
        currentPoliticalAction.report.images.length == 1 &&
        currentPoliticalAction.report.images[0].normalImage == null
      ) {
        images = []
      } else {
        for (let i = 0; i < currentPoliticalAction.report.images.length; i++) {
          currentPoliticalAction.report.images[i].blackImage != null
            ? images.push(currentPoliticalAction.report.images[i].blackImage)
            : images.push(currentPoliticalAction.report.images[i].normalImage)
        }
      }

      imgUploader.error = ''
      imgUploader.files = []
      imgUploader.dropped = 0
      imgUploader.imgs = images

      if (rejectedAttrs.length > 0) {
        rejectedAttrs.forEach(item => {
          headers.forEach(header => {
            if (item.target === header.attr) {
              header.comment = item.comment
            }
          })
        })
      }
    })

    const sentBackTitle = () => {
      if (currentPoliticalAction.report.sentBackItems.length > 0) {
        const sentBackTitles = []
        currentPoliticalAction.report.sentBackItems[0].items.forEach(
          sentBackItem => {
            sentBackTitles.push(sentBackItem.target)
          },
        )
        return sentBackTitles
      } else {
        return ''
      }
    }
    return {
      headers,
      currentPoliticalAction,
      getIcon,
      imgUploader,
      rejectHeaders,
      rejectedAttrs,
      sentBackTitle,
      ...useResultForm(),
      ...useDialog(),
      ...useCurrentUser(),
    }
  },
}
</script>
<style lang="scss" scoped>
.overview ::v-deep ol {
  list-style: decimal !important;
}
.overview ::v-deep ul {
  list-style: disc !important;
}
</style>
